/**
 * Privacy Hook
 *
 * Provides access to privacy consent status and data export functionality.
 * Shared between web and mobile apps.
 */

import { useQuery, useMutation } from 'convex/react';
import { api } from '@have-done/backend/convex/_generated/api';

/**
 * Get the current user's consent status
 * Returns null if not authenticated
 */
export function useConsentStatus() {
  return useQuery(api.privacy.getConsentStatus);
}

/**
 * Update analytics consent
 */
export function useUpdateAnalyticsConsent() {
  return useMutation(api.privacy.updateAnalyticsConsent);
}

/**
 * Export all user data (GDPR data portability)
 */
export function useExportUserData() {
  return useMutation(api.privacy.exportUserData);
}

/**
 * Request account deletion (starts 30-day grace period)
 */
export function useRequestAccountDeletion() {
  return useMutation(api.privacy.requestAccountDeletion);
}

/**
 * Cancel account deletion request
 */
export function useCancelAccountDeletion() {
  return useMutation(api.privacy.cancelAccountDeletion);
}

/**
 * Get deletion request status
 */
export function useDeletionStatus() {
  return useQuery(api.privacy.getDeletionStatus);
}

/**
 * Get audit log for current user
 */
export function useMyAuditLog(limit?: number) {
  return useQuery(api.auditLog.getMyAuditLog, { limit });
}
